import { put, takeLatest } from 'redux-saga/effects';
import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import packageServices from './services';
import packageActions from './actions';
import packageTypes from './types';

function* fetchV2PackagesRequest(action) {
	try {
		let response = yield sagaCallService(
			packageServices.fetchV2Packages,
			action,
			action.payload
		);
		yield put(packageActions.V2_fetchSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, packageActions.V2_fetchFailure);
	}
}

function* fetchV1PackagesRequest(action) {
	try {
		let response = yield sagaCallService(
			packageServices.fetchV1Packages,
			action,
			action.payload
		);
		yield put(packageActions.V1_fetchSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, packageActions.V1_fetchFailure);
	}
}

function* updatePackageStatusRequest(action) {
	try {
		let response = yield sagaCallService(
			packageServices.updateStatus,
			action,
			action.payload
		);
		yield put(packageActions.updateStatusSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, packageActions.updateStatusFailure);
	}
}

function* createPackageRequest(action) {
	try {
		let response = yield sagaCallService(
			packageServices.create,
			action,
			action.payload
		);
		yield put(packageActions.createSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, packageActions.createFailure);
	}
}

function* updatePackageRequest(action) {
	try {
		let response = yield sagaCallService(
			packageServices.update,
			action,
			action.payload
		);
		yield put(packageActions.updateSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, packageActions.updateFailure);
	}
}

function* getPackageRequest(action) {
	try {
		let response = yield sagaCallService(
			packageServices.BestSelling,
			action,
			action.payload
		);
		yield put(packageActions.getBestSellingSuccess(response.data));
	} catch (e) {
		// yield sagaErrorDispatcher(e, action, packageActions.getBestSellingFailure);
	}
}

const packageSagas = [
	takeLatest(packageTypes.V2_FETCH.REQUEST, fetchV2PackagesRequest),
	takeLatest(packageTypes.V1_FETCH.REQUEST, fetchV1PackagesRequest),
	takeLatest(packageTypes.UPDATE_STATUS.REQUEST, updatePackageStatusRequest),
	takeLatest(packageTypes.CREATE.REQUEST, createPackageRequest),
	takeLatest(packageTypes.UPDATE.REQUEST, updatePackageRequest),
	takeLatest(packageTypes.BEST_SELLING.REQUEST, getPackageRequest),
];

export default packageSagas;
